import { registerEvents } from "./skyward.ui.events";
import { JQueryInput } from "./types";
import FilterOptionSelector from "./vue/filterOptionSelector/FilterOptionSelector";

// defining this here so the FilterOptionSelector import gets used
customElements.define("sky-filteroptionselector", FilterOptionSelector);

const events =
{
    load: () => {}
};

registerEvents("filterOptionSelector", events);

export function getValue(selector: JQueryInput)
{
    const element = $(selector);

    if (element.length == 0 || element[0].tagName.toLowerCase() !== "sky-filteroptionselector")
    {
        return undefined;
    }

    const checkedElement = element.find(`input[type="radio"]:checked`);

    if (checkedElement.length == 0)
    {
        return undefined;
    }

    return checkedElement.val() as string;
}